import '../sass/ucg-gallery.scss';

jQuery(document).ready(($) => {
  const { id } = ucgGalleryVars;

  $(document).on('click', '.ucg-gallery .filter-photos .item', function () {
    if ($(window).width() < 960) {
      if ($(this).hasClass('active')) {
        $(this).siblings().slideDown();
      } else {
        $(this).addClass('active').siblings().removeClass('active').slideUp();
      }
    } else {
      $(this).addClass('active').siblings().removeClass('active');
    }
    const category = $(this).data('category');
    const vars = `post_id=${id}&category_name=${encodeURIComponent(category)}`;
    ucgAjaxPhotos(vars);
  });

  $(document).on('click', '.ucg-gallery .filter-tours .item', function () {
    if ($(window).width() < 960) {
      if ($(this).hasClass('active')) {
        $(this).siblings().slideDown();
      } else {
        $(this).addClass('active').siblings().removeClass('active').slideUp();
      }
    } else {
      $(this).addClass('active').siblings().removeClass('active');
    }
    const category = $(this).data('category');
    const vars = `post_id=${id}&category_name=${encodeURIComponent(category)}`;
    ucgAjaxTours(vars);
  });

  let ucgAjaxPhotosXhrCheck;
  function ucgAjaxPhotos(vars) {
    if (
      typeof ucgAjaxPhotosXhrCheck !== 'undefined' &&
      ucgAjaxPhotosXhrCheck.readyState != 4
    ) {
      ucgAjaxPhotosXhrCheck.abort();
    }
    ucgAjaxPhotosXhrCheck = $.ajax({
      url: ucgGalleryVars.ajaxUrl,
      type: 'post',
      data: {
        action: 'ajax_photos',
        fields: vars,
        security: ucgGalleryVars.ajaxSecurity,
      },
      success(response) {
        $('.ucg-gallery .photos').replaceWith(response);
        $('.ucg-gallery .photos .image').fadeOut().fadeIn();
        $('.ucg-gallery .tabs .item.photos')
          .addClass('active')
          .siblings()
          .removeClass('active');
        $('.ucg-gallery .filter-photos')
          .addClass('active')
          .siblings()
          .removeClass('active');
        $('.ucg-gallery .photos').addClass('active');
        $('.ucg-gallery .tours').removeClass('active');
        setTimeout(() => {
          $('#ucg_gallery').masonry({
            columnWidth: '.grid-item',
            gutter: 16,
            fitWidth: true,
            itemSelector: '.grid-item',
          });
        }, 1000);

        if ($('.ucg-gallery .photos.carousel .slides').children().length > 1) {
          $('.ucg-gallery .photos.carousel .slides').slick({
            arrows: false,
            autoplay: false,
            centerMode: true,
            cssEase: 'ease-in-out',
            dots: true,
            infinite: true,
            variableWidth: true,
            speed: 1000,
            slidesToShow: 3,
          });
        }
        if (
          $('.ucg-gallery .photos.carousel .navigator .thumbnails').children()
            .length > 1
        ) {
          $('.ucg-gallery .photos.carousel .navigator .thumbnails').slick({
            arrows: true,
            asNavFor: '.ucg-gallery .photos.carousel .slides',
            autoplay: false,
            autoplaySpeed: 5000,
            centerMode: true,
            dots: false,
            focusOnSelect: true,
            infinite: true,
            nextArrow:
              '<p class="slick-next"><i class="fa fa-angle-right"></i></p>',
            pauseOnHover: false,
            pauseonFocus: false,
            prevArrow:
              '<p class="slick-prev"><i class="fa fa-angle-left"></i></p>',
            slidesToScroll: 1,
            slidesToShow: 5,
            responsive: [
              {
                breakpoint: 1024,
                settings: {
                  slidesToShow: 5,
                  slidesToScroll: 5,
                },
              },
              {
                breakpoint: 600,
                settings: {
                  slidesToShow: 2,
                  slidesToScroll: 2,
                },
              },
            ],
            speed: 1000,
          });
        }
      },
    });
  }

  let ucgAjaxToursXhrCheck;
  function ucgAjaxTours(vars) {
    if (
      typeof ucgAjaxToursXhrCheck !== 'undefined' &&
      ucgAjaxToursXhrCheck.readyState != 4
    ) {
      ucgAjaxToursXhrCheck.abort();
    }
    ucgAjaxToursXhrCheck = $.ajax({
      url: ucgGalleryVars.ajaxUrl,
      type: 'post',
      data: {
        action: 'ajax_tours',
        fields: vars,
        security: ucgGalleryVars.ajaxSecurity,
      },
      success(response) {
        $('.ucg-gallery .tours').replaceWith(response);
        $('.ucg-gallery .tours .tour').fadeOut().fadeIn();
        $('.ucg-gallery .tabs .item.tours')
          .addClass('active')
          .siblings()
          .removeClass('active');
        $('.ucg-gallery .filter-tours')
          .addClass('active')
          .siblings()
          .removeClass('active');
        $('.ucg-gallery .tours').addClass('active');
        $('.ucg-gallery .photos').removeClass('active');
      },
    });
  }

  $(window).resize(() => {
    setFilter();
  });

  function setFilter() {
    if ($(window).width() < 960) {
      $('.ucg-gallery .filter-photos .item')
        .not('.active')
        .not('.name')
        .slideUp();
      $('.ucg-gallery .filter-tours .item')
        .not('.active')
        .not('.name')
        .slideUp();
    } else {
      $('.ucg-gallery .filter-photos .item').slideDown();
      $('.ucg-gallery .filter-tours .item').slideDown();
    }
  }
});
